import React, { useEffect, useState, useRef, useContext } from 'react';
import CommonCheckbox from '../../common/components/CommonCheckBox/CommonCheckbox';
import {
  table_header,
  table_body,
  date_block,
  more_options,
  lead_details,
  creditScoreColmn
} from './AllLeads.module.css';
import moment from 'moment';
import MoreHorizIcon from '@material-ui/icons/MoreHoriz';
import EditIcon from '@material-ui/icons/Edit';
import AddCircleOutlineIcon from '@material-ui/icons/AddCircleOutline';
import EditLead from './EditLead';
import { setApplicantionInfo } from '../../common/utils/applicantionInfo';
import { navigate } from 'gatsby';
import { getAcl } from '../../common/utils/acl-utils';
import AssignMultipleLeads from './AssignMultipleLeads';
import AssignOwner from '../../../src/containers/RMDashboard/AssignOwner';
import MakeACall from '../../components/MakeACall/MakeACall';
import CallLog from '../CallLog/CallLog';
import PhoneInTalkIcon from '@material-ui/icons/PhoneInTalk';
const commonStyle = `font-roboto font-normal mx-auto text-center capitalize ${table_body}`;
const commonHeaderStyle = `text-center mx-auto  text-sm font-khand ${table_header}`;
import ChatBubbleOutlineIcon from '@material-ui/icons/ChatBubbleOutline';
const whatsApp_icon = '/images/icons/whatsApp/WhatsApp.svg';
import PhoneIcon from '@material-ui/icons/Phone';
import { makeStyles } from '@material-ui/core/styles';
import Badge from '@material-ui/core/Badge';
import InsertDriveFileIcon from '@material-ui/icons/InsertDriveFile';
import { numberInTextFormat } from '../../common/constants/numberInTextFormat';

const AllLeadsColumnData = (
  LeadSelectionData,
  setLeadSelectionData,
  setShowAssignLeadBtn,
  getLeadData,
  notificationMessage,
  setShowWhatsApp,
  setUSerDataForWA,
  setCurrentApplicantId,
  setShowWhatsAppCheckList,
  setCurrDocLeadId
) => {
  const [isChecked, setIsChecked] = useState(false);
  const [userType, setUserType] = useState(
    getAcl()?.acl?.can_assign_rm ? true : false
  );
  const [countMessage, setCountMessage] = useState({});
  useEffect(() => {
    const lenWaMessage = notificationMessage?.wa_notification?.length;
    const lastMessage =
      notificationMessage?.wa_notification?.[lenWaMessage - 1];
    const lastMesgLead = lastMessage?.leadId;
    setCountMessage({
      ...(countMessage || {}),
      [lastMesgLead]: (countMessage?.[lastMesgLead] || 0) + 1
    });
  }, [notificationMessage?.wa_notification?.length]);

  const getLoanTypeId = loanType => {
    switch (loanType) {
      case 'Personal Loan':
        return 13;
      case 'Business Loan':
        return 12;
      case '2 Wheeler Loan':
        return 14;
      case 'Home Loan':
        return 1;
      case 'LAP':
        return 2;
      default:
        return 1;
    }
  };
  const [
    isOkayToChnageCheckboxValue,
    setIsOkayToChnageCheckboxValue
  ] = useState(true);

  const handleMianCheckbox = () => {
    setIsOkayToChnageCheckboxValue(true);
    setIsChecked(!isChecked);
  };

  const HeaderCheckBox = () => (
    <div className="w-full">
      <CommonCheckbox
        checked={isChecked}
        name="selectlead"
        value={isChecked}
        onChange={handleMianCheckbox}
      />
    </div>
  );

  const getPhoneNumberAndimage = row => {
    return (
      <div className="table text-center mx-auto">
        <MakeACall
          phoneNumber={row?.leadApplicantPhone}
          leadId={row?.leadId}
          applicantId={row?.leadMainApplicantId}
          PhoneNumberClasses="hidden"
          CustomIcon={PhoneIcon}
          phoneCallStyles={{ color: '#0A4549', height: '18px' }}
          callWrapperStyle={{
            height: ' 30px',
            width: '32px',
            paddingTop: '6px'
          }}
          callWrapperClasses="bg-white rounded-full shadow px-1 py-1 box-shadow"
          loadingWrapperClasses="-mt-0.5"
        />
      </div>
    );
  };

  const WhatsAppMessage = ({ row }) => {
    const handleClick = () => {
      const data = {
        applicationStatus: row?.status || '',
        leadId: row?.leadId,
        leadApplicantId: row?.leadMainApplicantId,
        applicantInfo: {
          id: row?.leadMainApplicantId,
          mainApplicant: 'Main Applicant',
          phoneNumber: row?.phoneNumber
        },
        leadData: {
          loanAmount: row?.loanAmount || '---',
          loanProduct: row?.loanProduct || '---'
        }
      };
      setUSerDataForWA(data);
      setShowWhatsApp(true);
      setCountMessage({
        ...(countMessage || {}),
        [row?.leadId]: 0
      });
    };
    return (
      <div className="w-full">
        <div className="mx-auto text-center w-full cursor-pointer">
          <Badge
            badgeContent={countMessage?.[row?.leadId || 0]}
            color="secondary"
          >
            <img
              src={whatsApp_icon}
              style={{ height: '35px' }}
              onClick={handleClick}
            />
          </Badge>
        </div>
      </div>
    );
  };
  const getStartApplicationBtn = row => {
    let applicationDetails = {
      leadId: row.leadId,
      leadApplicantId: row.leadMainApplicantId,
      applicationStatus: row.status,
      leadData: row
    };
    const handleClick = async () => {
      await setApplicantionInfo(applicationDetails);
    };
    const handleViewPD = async () => {
      await handleClick();
      navigate('/app/dashboard/lead/view/pd/all');
    };

    const handleReviewPD = async () => {
      await handleClick();
      let productId = await getLoanTypeId(row?.loanProduct);
      navigate(`/app/dashboard/lead/pd?loanType=${productId}`);
    };
    const handleStartPD = async () => {
      await handleClick();
      let productId = await getLoanTypeId(row?.loanProduct);
      navigate(`/app/dashboard/lead/pd?loanType=${productId}`);
    };

    if (row.status == 'Lead Rejected')
      return (
        <button
          className="bg-grey-delta capitalize py-2 px-2 w-full rounded text-white"
          onClick={handleViewPD}
        >
          View PD
        </button>
      );
    if (row.pdStatus == 'InProgress')
      return (
        <button
          className="bg-yellow-goldenGrass capitalize py-2 px-2 w-full rounded text-white"
          onClick={handleReviewPD}
        >
          Review PD
        </button>
      );
    else
      return (
        <button
          className="bg-green-tePapaGreen capitalize py-2 px-2 w-full rounded text-white"
          onClick={handleStartPD}
        >
          Start PD
        </button>
      );
  };

  return [
    {
      name: <HeaderCheckBox />,
      selector: 'selectLead',
      sortable: false,
      cell: (row, index) => {
        const [doForceRender, setForceRender] = useState(false);

        const showHideAssignButton = () => {
          for (var key in LeadSelectionData) {
            if (LeadSelectionData[key]) return setShowAssignLeadBtn(true);
          }
          return setShowAssignLeadBtn(false);
        };

        const chanageSelectionList = newValue => {
          let newList = LeadSelectionData;
          newList[row.leadId] = newValue;
          setLeadSelectionData(newList);
          setForceRender(!doForceRender);
          showHideAssignButton();
        };

        useEffect(() => {
          if (isOkayToChnageCheckboxValue) chanageSelectionList(isChecked);
        }, [isChecked]);

        useEffect(() => {
          setForceRender(!doForceRender);
          showHideAssignButton();
        }, [LeadSelectionData]);

        const handleChange = () => {
          chanageSelectionList(!LeadSelectionData[row.leadId]);
          setIsOkayToChnageCheckboxValue(false);
          setIsChecked(false);
        };

        return (
          <div className=" mb-5 mx-auto">
            <CommonCheckbox
              checked={LeadSelectionData[row.leadId]}
              name="selectlead"
              value={LeadSelectionData[row.leadId]}
              onChange={handleChange}
              isForceRender={doForceRender}
            />
          </div>
        );
      },
      width: '40px',
      omit: true
    },

    {
      name: (
        <p className={`${commonHeaderStyle} ${lead_details}`}>Lead Details</p>
      ),
      selector: 'name',
      sortable: true,
      cell: row => (
        <div className={`${commonStyle} w-full  ml-3`}>
          <p className="text-left text-grey-2100" style={{ fontWeight: '300' }}>
            {row.leadId}
          </p>
          <p className="text-green-500  text-left capitalize">{`${row?.leadName
            ?.firstName || ''} ${row.leadName?.middleName || ''} ${row?.leadName
            ?.lastName || ''}`}</p>
        </div>
      ),
      minWidth: '150px !important '
    },
    {
      name: <p className={`${commonHeaderStyle}`}>Source</p>,
      selector: 'source',
      sortable: true,
      cell: row => (
        <p className={commonStyle}>{row.leadSource ? row.leadSource : '---'}</p>
      ),
      minWidth: '70px'
    },
    {
      name: <p className={`${commonHeaderStyle}`}>Sourcing Date</p>,
      selector: 'sourcingDate',
      sortable: true,
      cell: row => (
        <div className={commonStyle} style={{ width: 'fit-content' }}>
          {row.leadCreatedAt ? (
            <div className="w-full text-left">
              <p className={` text-left`}>
                {moment(row.leadCreatedAt).format('YYYY-MM-DD')}
              </p>
              <p className={`text-left ${date_block}`}>
                {moment(row.leadCreatedAt).format('hh:mm A')}
              </p>
            </div>
          ) : (
            '---'
          )}
        </div>
      )
    },

    {
      name: <p className={`${commonHeaderStyle}`}>City</p>,
      selector: 'city',
      sortable: true,
      cell: row => (
        <p className={commonStyle}>
          {row.propertyCity ? row.propertyCity : '---'}
        </p>
      )
    },
    {
      name: <p className={`${commonHeaderStyle}`}>RM assigned</p>,
      selector: 'rmName',
      sortable: true,
      cell: row => {
        const [showAssignLeads, setShowAssignLeads] = useState(false);
        return (
          <div
            className={`w-full ${commonStyle} ${
              userType ? 'cursor-pointer' : ''
            }`}
            onClick={() => (userType ? setShowAssignLeads(true) : null)}
          >
            {row?.rmName?.firstName ? (
              <p className={userType ? ` text-blue-500 font-medium` : ''}>
                {`${row?.rmName?.firstName || ''} ${row?.rmName?.middleName ||
                  ''} ${row?.rmName?.lastName || ''}`}
              </p>
            ) : (
              '---'
            )}
            {showAssignLeads ? (
              <AssignOwner
                leadId={row?.leadId}
                name={`${row?.leadName?.firstName || ''} ${row.leadName
                  ?.middleName || ''} ${row?.leadName?.lastName || ''}`}
                ownerName={`${row?.rmName?.firstName || ''}  ${row?.rmName
                  ?.middleName || ''} ${row?.rmName?.lastName || ''}`}
                row={row}
                setShowReassign={setShowAssignLeads}
                onSuccess={getLeadData}
                header="Current RM"
                actionHeader="Assign New RM"
                submitText="Changing RM for the lead. Please wait..."
              />
            ) : null}
          </div>
        );
      }
    },
    {
      name: <p className={`${commonHeaderStyle}`}>Loan Type</p>,
      selector: 'loanType',
      sortable: true,
      cell: row => (
        <p className={commonStyle}>
          {row?.loanProduct ? row.loanProduct : '---'}
        </p>
      )
    },
    {
      name: <p className={`${commonHeaderStyle}`}>Status</p>,
      selector: 'status',
      sortable: true,
      cell: row => {
        return <StatusField row={row} getLeadData={getLeadData} />;
      }
    },
    {
      name: <p className={`${commonHeaderStyle}`}>Sub Status</p>,
      selector: 'subStatus',
      sortable: true,
      cell: row => (
        <p className={commonStyle}>{row.subStatus ? row.subStatus : '---'}</p>
      )
    },
    {
      name: <p className={`${commonHeaderStyle}`}>Credit Score</p>,
      selector: 'creditScore',
      sortable: true,
      cell: row => {
        const handleClick = () => {
          setApplicantionInfo({
            leadId: row.leadId,
            applicationStatus: row.status
          });
          navigate(
            `/app/leadprofile/creditReport/${row.leadMainApplicantId}?backPage=allLeads`
          );
        };
        return (
          <p
            className={`${commonStyle} ${creditScoreColmn} ${
              row.creditScore ? 'cursor-pointer font-bold' : ''
            }`}
            onClick={row.creditScore ? handleClick : null}
          >
            {row.creditScore ? row.creditScore : '---'}
          </p>
        );
      }
    },
    {
      name: <p className={`${commonHeaderStyle}`}>Amt Req</p>,
      selector: 'amtReq',
      sortable: false,
      cell: row => (
        <div className={commonStyle} style={{ width: 'fit-content' }}>
          <p className={` text-right`}>
            {row?.loanAmount && <span> &#8377;</span>}
            {numberInTextFormat(row?.loanAmount)}
          </p>
        </div>
      )
    },

    {
      name: <p className={`${commonHeaderStyle}`}>Last Updated on</p>,
      selector: 'lastUpdatedOn',
      sortable: true,
      cell: row => (
        <div className={commonStyle} style={{ width: 'fit-content' }}>
          {row?.leadUpdatedAt ? (
            <div className="w-full text-left">
              <p className={` text-left`}>
                {moment(row.leadUpdatedAt).format('YYYY-MM-DD')}
              </p>
              <p className={`text-left ${date_block}`}>
                {moment(row.leadUpdatedAt).format('hh:mm A')}
              </p>
            </div>
          ) : (
            '----'
          )}
        </div>
      ),
      minWidth: '113px !important'
    },
    {
      name: <p className={`${commonHeaderStyle}`}>Next Follow up on</p>,
      selector: 'nextFollowUpOn',
      sortable: true,
      cell: row => (
        <div className={commonStyle} style={{ width: 'fit-content' }}>
          {row.nextFollowUpOn ? (
            <div className="w-full text-left">
              <p className={` text-left`}>
                {moment(row.nextFollowUpOn).format('YYYY-MM-DD')}
              </p>
              <p className={`text-left ${date_block}`}>
                {moment(row.nextFollowUpOn).format('hh:mm A')}
              </p>
            </div>
          ) : (
            '---'
          )}
        </div>
      ),
      minWidth: '113px !important'
    },
    {
      name: <p className={`${commonHeaderStyle}`}></p>,
      selector: 'details',
      sortable: false,
      cell: row => (
        <div className="mx-auto text-center w-full px-5">
          {getPhoneNumberAndimage(row)}
        </div>
      )
    },

    {
      name: <p className={`${commonHeaderStyle}`}></p>,
      selector: 'whatsAppDetails',
      sortable: false,
      cell: row => <WhatsAppMessage row={row} />
    },
    {
      name: <p className={`${commonHeaderStyle}`}></p>,
      selector: 'pd',
      sortable: false,
      cell: row => getStartApplicationBtn(row)
    },

    {
      name: <p className={`${commonHeaderStyle}`}>Action</p>,
      selector: 'action',
      sortable: false,
      cell: row => {
        const [showMore, setShowMore] = useState(false);
        return (
          <div className={`w-full ${commonStyle}`}>
            <p
              className={`${commonStyle} cursor-pointer`}
              onClick={() => setShowMore(true)}
            >
              <MoreHorizIcon />
            </p>
            {showMore ? (
              <ShowMore
                setShowMore={setShowMore}
                showMore={showMore}
                rowData={row}
                getLeadData={getLeadData}
                setCurrentApplicantId={setCurrentApplicantId}
                setShowWhatsAppCheckList={setShowWhatsAppCheckList}
                setCurrDocLeadId={setCurrDocLeadId}
              />
            ) : null}
          </div>
        );
      }
    }
  ];
};

const ShowMore = ({
  showMore,
  setShowMore,
  rowData,
  getLeadData,
  setCurrentApplicantId,
  setShowWhatsAppCheckList,
  setCurrDocLeadId
}) => {
  const moreRef = useRef('');
  const [showModal, setShowModal] = useState(false);

  useEffect(() => {
    setApplicantionInfo({
      leadId: rowData.leadId,
      applicationStatus: rowData.status
    });
  }, []);

  const handleClicks = e => {
    if (showMore && !moreRef.current.contains(e.target)) {
      setShowMore(false);
    }
  };
  useEffect(() => {
    document.body.addEventListener('click', handleClicks);
    return () => document.body.removeEventListener('click', handleClicks);
  }, []);

  const iconCommonStyle = {
    color: '#4c4c4c',
    fontSize: '17px'
  };
  const textCommonStyle = { color: '#4c4c4c' };

  return (
    <div
      className={`w-full absolute bg-white rounded py-3 px-3 shadow right-0 text-left ${more_options}`}
      ref={moreRef}
    >
      <ul className="px-1 my-2">
        <li
          className="items-center cursor-pointer"
          onClick={() => {
            setShowModal(true);
          }}
        >
          <EditIcon style={iconCommonStyle} />
          <span className="ml-4 text-sm" style={textCommonStyle}>
            Edit
          </span>
          {showModal && (
            <EditLead
              showModal={showModal}
              setShowModal={setShowModal}
              rowData={rowData}
              onUpdation={getLeadData}
            />
          )}
        </li>
        <li
          className="cursor-pointer mt-2"
          onClick={() => {
            navigate(`/app/calllog/${rowData?.leadId}`);
          }}
        >
          <PhoneInTalkIcon style={{ fontSize: '18px' }} />
          <span className="ml-4 text-sm" style={textCommonStyle}>
            Call Logs
          </span>
        </li>
        <li className="mt-2 items-center cursor-pointer">
          <AddCircleOutlineIcon style={iconCommonStyle} />
          <span className="ml-4 text-sm" style={textCommonStyle}>
            Add Another
          </span>
        </li>
        <li className="mt-2 items-center cursor-pointer">
          <MakeACall
            phoneNumber={rowData?.leadApplicantPhone}
            leadId={rowData?.leadId}
            applicantId={rowData?.leadMainApplicantId}
            phoneCallStyles={{ color: '#4c4c4c', fontSize: '17px' }}
            PhoneNumberClasses={`text-grey-2233 ml-1 text-sm`}
            spinnerStyles={{ width: '18px', height: '18px' }}
            onSuccessCall={() => setShowMore(false)}
            onFailureCall={() => setShowMore(false)}
          />
        </li>
        <li
          className="mt-2 items-center cursor-pointer flex"
          onClick={() => {
            setShowWhatsAppCheckList(true);
            setCurrentApplicantId(rowData?.leadMainApplicantId);
            setCurrDocLeadId(rowData?.leadId);
          }}
        >
          <span className="mr-1">
            <InsertDriveFileIcon className="h-4" />
          </span>
          <span className="font-roboto font-nomal text-sm ">Send Document</span>
        </li>
      </ul>
    </div>
  );
};

const StatusField = ({ row, getLeadData }) => {
  const [showEditModal, setShowEditModal] = useState(false);

  const getStatusColors = status => {
    if (status == 'Follow Up') return 'text-orange-600 bg-orange-50';
    else if (status == 'Not Interested') return 'text-red-100 bg-red-600';
    else if (status == 'Interested') return 'text-green-1350 bg-green-50';
    else if (status == 'Lead Rejected') return 'text-red-100 bg-red-600';
    else if (status == 'Open') return 'text-blue-900 bg-blue-100';
    else if (status == 'New Lead') return 'text-green-1000 bg-blue-100';
    else return 'text-green-1350 bg-green-50';
  };

  const handleClickEvent = () => {
    setApplicantionInfo({
      leadId: row.leadId,
      applicationStatus: row.status
    });
    setShowEditModal(true);
  };

  return (
    <React.Fragment>
      {showEditModal ? (
        <EditLead
          showModal={showEditModal}
          setShowModal={setShowEditModal}
          rowData={row}
          onUpdation={getLeadData}
        />
      ) : null}

      <p
        className={`py-2 mx-1 w-full rounded font-normal cursor-pointer ${getStatusColors(
          row.status
        )}`}
        onClick={() => handleClickEvent()}
      >
        {row.status ? row.status : '---'}
      </p>
    </React.Fragment>
  );
};
export default AllLeadsColumnData;
